<template>
  <aside class="catalog-person-search-panel" :aria-label="$t('catalogPersonSearchTitle')">
    <h3 v-if="showTitle" class="catalog-person-search-panel__title">{{ $t("catalogPersonSearchTitle") }}</h3>

    <el-form label-position="top" class="catalog-person-search-panel__form" @submit.prevent>
      <el-form-item class="catalog-person-search-panel__mode">
        <el-radio-group
          class="catalog-person-search-panel__mode-group"
          :model-value="searchMode"
          @update:model-value="$emit('update:searchMode', $event)"
        >
          <el-radio :value="searchModeAsan">{{ $t("catalogSearchModeAsan") }}</el-radio>
          <el-radio :value="searchModeManual">{{ $t("catalogSearchModeManual") }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <fieldset class="catalog-person-search-panel__fields" :disabled="isManualMode">
        <el-form-item class="catalog-person-search-panel__pin" :label="$t('pinCode')">
          <el-input
            :model-value="pin"
            maxlength="7"
            class="catalog-person-form__pin-input catalog-person-search-panel__pin-field"
            @update:model-value="$emit('update:pin', $event)"
          />
        </el-form-item>

        <el-form-item
          class="catalog-person-form__doc-item catalog-person-search-panel__doc"
          :label="$t('catalogDocSeriesNumber')"
        >
          <div class="catalog-person-form__doc-combo">
            <el-input
              :model-value="docSeries"
              maxlength="3"
              class="catalog-person-form__doc-series"
              :placeholder="$t('series')"
              @update:model-value="$emit('update:docSeries', $event)"
            />
            <span class="catalog-person-form__doc-divider" aria-hidden="true" />
            <el-input
              :model-value="docNumber"
              class="catalog-person-form__doc-number"
              :placeholder="$t('number')"
              @update:model-value="$emit('update:docNumber', $event)"
            />
          </div>
        </el-form-item>

        <div class="catalog-person-search-panel__actions">
          <el-button
            class="catalog-person-form__asan-btn catalog-person-search-panel__asan-btn"
            type="primary"
            native-type="button"
            :loading="loading"
            :disabled="loading || isManualMode"
            @click.prevent="$emit('search')"
          >
            ASAN
          </el-button>
        </div>
      </fieldset>
    </el-form>
  </aside>
</template>

<script>
import { CATALOG_PERSON_SEARCH_MODE } from "./catalogPersonSearch.js";

export default {
  name: "CatalogPersonSearchPanel",
  props: {
    showTitle: { type: Boolean, default: true },
    pin: { type: String, default: "" },
    docSeries: { type: String, default: "" },
    docNumber: { type: String, default: "" },
    searchMode: {
      type: String,
      default: CATALOG_PERSON_SEARCH_MODE.ASAN,
    },
    loading: { type: Boolean, default: false },
  },
  emits: ["update:pin", "update:docSeries", "update:docNumber", "update:searchMode", "search"],
  computed: {
    searchModeAsan() {
      return CATALOG_PERSON_SEARCH_MODE.ASAN;
    },
    searchModeManual() {
      return CATALOG_PERSON_SEARCH_MODE.MANUAL;
    },
    isManualMode() {
      return this.searchMode === CATALOG_PERSON_SEARCH_MODE.MANUAL;
    },
  },
};
</script>
